module.exports = __webpack_public_path__ + "static/img/swiper3.36c84f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper/swiper3.png
// module id = j4yu
// module chunks = 1